import axios from 'axios'
import store from '@/store'

const API_BASE = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app/caddie-house'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

function getFormHeaders () {
  return {
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const caddieHouseAPI = {
  // Obtener lista de bolsas activas
  async getBags (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/bags/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching bags:', error)
      throw error
    }
  },

  // Obtener bolsa específica
  async getBag (bagId) {
    try {
      const response = await axios.get(`${API_BASE}/bags/${bagId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching bag:', error)
      throw error
    }
  },

  // Crear nuevo registro de inventario (guardar checklist)
  async createInventoryRecord (inventoryData) {
    try {
      const response = await axios.post(`${API_BASE}/inventory/`, inventoryData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating inventory record:', error)
      throw error
    }
  },

  // Obtener histórico de inventarios
  async getInventoryHistory (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/inventory/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching inventory history:', error)
      throw error
    }
  },

  // Obtener detalle de un inventario específico
  async getInventoryDetail (inventoryId) {
    try {
      const response = await axios.get(`${API_BASE}/inventory/${inventoryId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching inventory detail:', error)
      throw error
    }
  },

  // Obtener estadísticas diarias
  async getStats (date = null) {
    try {
      const params = date ? { date } : {}
      const response = await axios.get(`${API_BASE}/stats/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching stats:', error)
      throw error
    }
  },

  // Cargar archivo de librillo del torneo
  async uploadTournamentFile (file, tournamentDate, notes = '') {
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('tournament_date', tournamentDate)
      if (notes) {
        formData.append('notes', notes)
      }

      const response = await axios.post(`${API_BASE}/tournament-files/`, formData, {
        headers: getFormHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error uploading tournament file:', error)
      throw error
    }
  }
}

// Utilidades para formatear datos
export const caddieHouseUtils = {
  // Calcular total de bastones
  calculateTotalClubs (checklist) {
    return (
      (checklist.clubs_irons || 0) +
      (checklist.clubs_driver || 0) +
      (checklist.clubs_putter || 0) +
      (checklist.clubs_hybrid || 0)
    )
  },

  // Calcular estadísticas desde array de bolsas
  calculateStats (bags) {
    return {
      bags_total: bags.length,
      delivered_bags: bags.filter(b => b.status === 'entrega').length,
      received_bags: bags.filter(b => b.status === 'recepcion').length,
      pending_bags: bags.filter(b => b.status !== 'completado').length
    }
  },

  // Validar estructura de checklist
  isValidChecklist (checklist) {
    const requiredFields = [
      'clubs_irons',
      'clubs_driver',
      'clubs_putter',
      'clubs_hybrid',
      'covers_woods',
      'covers_putters',
      'has_umbrella',
      'has_pullcar',
      'has_towel'
    ]

    return requiredFields.every(field => field in checklist)
  },

  // Validar datos de archivo
  isValidFile (file, maxSizeMB = 10) {
    const allowedTypes = [
      'application/pdf',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]

    const maxSizeBytes = maxSizeMB * 1024 * 1024

    if (!allowedTypes.includes(file.type)) {
      throw new Error('Formato de archivo no permitido. Use PDF, Excel o Word.')
    }

    if (file.size > maxSizeBytes) {
      throw new Error(`El archivo es muy grande. Máximo ${maxSizeMB}MB.`)
    }

    return true
  }
}
